import _ from 'lodash'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { RECAPTCHA_ENABLED } from '../environment'
import { generateRecaptchaToken } from './recapctcha'

export const getLaiskeyFromPath = (path: string, restoreSpaces: boolean = false) => {
  const match = path.match('/([X0-9]{15,})')
  const laisKey = match && match.length >= 2 ? match[1] : ''
  if (restoreSpaces) return replaceXWithSpace(laisKey)
  return laisKey
}

export const getCoordinatesFromPath = (path: string) => {
  const match = path.match('(-?[0-9]+.?[0-9]*),(-?[0-9]+.?[0-9]*),([0-9]*)')
  if (match && match.length === 4) {
    return {
      latitude: Number(match[1]),
      longitude: Number(match[2]),
      radius: Number(match[3])
    }
  }
  return null
}

export const replaceXWithSpace = (original: string) => {
  return _.replace(original, new RegExp('X', 'g'), ' ')
}

export const replaceSpaceWithX = (original: string) => {
  return _.replace(original, new RegExp(' ', 'g'), 'X')
}

export const addRecaptchaToURL = async (url: string) => {
  let recaptchaToken: string | undefined
  if (RECAPTCHA_ENABLED) {
    recaptchaToken = await generateRecaptchaToken()
    return url + '?recaptchaV3Key=' + recaptchaToken
  }
  return url
}

export const useQuery = () => {
  const { search } = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}

export const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
})